module.exports = __webpack_public_path__ + "img/9788989874355.a5aec49d.jpg";